import axios from "../api/axios"
import Logout from "../components/Logout"

/**
 * Checks to see if the cached version is the same as the server/site version.
 * If not, a refresh will be initiated.
 */
export const checkSiteVersion = () => {
  try{
    axios.get(`${window.location.origin}/version.txt?t=${Date.now()}`, { withCredentials: true })
      .then(r => {
        try{
          const serverVersion = parseInt(r?.data ?? "0")
          const clientVersion = parseInt(localStorage.getItem("app_version") ?? "0")

          if(!clientVersion || serverVersion > clientVersion){
            console.info("new version detected.")
            localStorage.setItem("app_version", serverVersion.toString())            
            window.location.href = window.location.href;
          }
        }catch(e){
          console.error(e)
          Logout()
        }         
      })
  }catch(e){
    console.error(e)
    Logout()
  } 
}